import { cloudCode } from "@/modules/cloud";

export function updateCameraStationControls({
  xmppLogin,
  cameraControls
}: {
  xmppLogin: string;
  cameraControls: CameraControls;
}): Promise<ParseCameraDevice> {
  return cloudCode.run("updateCameraStationControls", {
    xmppLogin,
    cameraControls
  });
}

export async function getDevicesLatestActivity() {
  const response = (await cloudCode.run("getDevicesLatestActivity")) as DeviceActivity[];
  return response;
}

// export function updateCloudSettings(updatedParams: Keyable) {
//   return cloudCode.run("updateCloudSettings", { updatedParams });
// }

export function getCameraStationPreview(xmppLogin: string): Promise<EncodedPreviewStatus> {
  return cloudCode.run("getCameraStationPreview", { xmppLogin });
}
